import React from 'react'
import { useForm } from './form'
import { Label } from './common/label'

const accessData = [
  {
    id: 'null',
    name: 'Only assigned users or groups',
    displayOrder: 1
  },
  {
    id: 3,
    name: 'All users',
    displayOrder: 3
  },
  {
    id: 2,
    name: 'All users in this organization',
    displayOrder: 4
  }
]

const valueAsFormat = value => {
  if (value === 'null') {
    return null
  }

  return parseInt(value)
}

export const FormSimpleCourseAccess = ({ name, label }) => {
  const { register } = useForm(name, { valueAsFormat: valueAsFormat, shouldDirty: true })

  return (
    <React.Fragment>
      <Label name={name} label={label} required={true}>
        <select className="form-control text-capitalize" {...register()}>
          {accessData &&
            accessData.map((item, i) =>
              <option key={i} value={item.id}>
                {item.name}
              </option>
            )}
        </select>
      </Label>
    </React.Fragment>
  )
}
